import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Divider, DrawerBody, DrawerContent, Flex, mode, Text, useColorMode } from '@abb/uikit';
import { Settings03 } from '@abb/uikit/icons/outline/general';
import { User03 } from '@abb/uikit/icons/outline/users';
import { useDependencies } from 'hooks';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Sidebar } from '../Sidebar';
import { ColorModeResponsive } from './ColorModeResponsive';
import { CustomerModal } from './CustomerModal';
import { HeaderResponsive } from './HeaderResponsive';
import { LanguageResponsive } from './LanguageResponsive';
import { Products } from './products';
export const Responsive = (param)=>{
    let { onClose, onToggle } = param;
    var _userService_getProcessClaims;
    const { t } = useTranslation('common');
    const { colorMode } = useColorMode();
    const push = useNavigate();
    const { userService } = useDependencies();
    const isDirector = userService === null || userService === void 0 ? void 0 : (_userService_getProcessClaims = userService.getProcessClaims) === null || _userService_getProcessClaims === void 0 ? void 0 : _userService_getProcessClaims.isDirector;
    const handleNavigate = ()=>{
        push('/settings/info');
    };
    const handleNavigateUsers = ()=>{
        push(`/sections-user-info`);
    };
    useEffect(()=>{
        //! gleap drower ve modalin ustunde gorsenmesin.
        const el = document.querySelector('.bb-feedback-button');
        if (el) {
            el.style.zIndex = '4';
        }
    }, []);
    return /*#__PURE__*/ _jsx(DrawerContent, {
        m: 2,
        borderRadius: "24px",
        background: mode('#F0F0F0', '#0A0B0D')({
            colorMode
        }),
        children: /*#__PURE__*/ _jsxs(DrawerBody, {
            p: "0",
            overflow: "auto",
            borderRadius: "24px",
            children: [
                /*#__PURE__*/ _jsx(HeaderResponsive, {
                    onCloseSidebar: onClose
                }),
                /*#__PURE__*/ _jsx(Products, {}),
                /*#__PURE__*/ _jsx(Sidebar, {
                    isLargerThanMd: false,
                    onSidebarOpen: onToggle
                }),
                /*#__PURE__*/ _jsx(Box, {
                    p: "4px 16px",
                    my: 1,
                    children: /*#__PURE__*/ _jsx(Divider, {
                        bg: mode('#0A0B0D1F', '#FFFFFF14')({
                            colorMode
                        })
                    })
                }),
                /*#__PURE__*/ _jsxs(Flex, {
                    gap: "12px",
                    alignItems: "center",
                    p: "12px 24px",
                    onClick: handleNavigate,
                    children: [
                        /*#__PURE__*/ _jsx(Settings03, {
                            color: mode('#2D3748', '#F0F0F0')({
                                colorMode
                            }),
                            width: "18px",
                            height: "18px"
                        }),
                        /*#__PURE__*/ _jsxs(Text, {
                            color: mode('#2D3748', '#F0F0F0')({
                                colorMode
                            }),
                            children: [
                                " ",
                                t('user_settings.settings')
                            ]
                        })
                    ]
                }),
                isDirector && /*#__PURE__*/ _jsxs(Flex, {
                    gap: "12px",
                    p: "12px 24px",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ _jsx(User03, {
                            width: "18px",
                            height: "18px",
                            onClick: handleNavigateUsers
                        }),
                        /*#__PURE__*/ _jsxs(Text, {
                            color: mode('#2D3748', '#F0F0F0')({
                                colorMode
                            }),
                            children: [
                                " ",
                                t('userInfo')
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(ColorModeResponsive, {
                    onSidebarOpen: onClose
                }),
                /*#__PURE__*/ _jsx(LanguageResponsive, {
                    onSidebarOpen: onClose
                }),
                /*#__PURE__*/ _jsx(Box, {
                    position: {
                        base: 'sticky',
                        md: 'absolute'
                    },
                    bottom: "8px",
                    borderBottomRadius: "24px",
                    w: "100%",
                    children: /*#__PURE__*/ _jsx(CustomerModal, {
                        onSidebarOpen: onClose
                    })
                })
            ]
        })
    });
};
